import { Paginator } from "~/@shared/api-types/Paginator"
import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"

import { NewGradJob } from "../_types"

const PATH = "/new-grad-jobs/pickup"

type GetNewGradJobsPickupQuery = {
  page?: number
}

export type GetNewGradJobsPickup = Paginator<NewGradJob>

export const fetchGetNewGradJobsPickup = defineFetcher(
  (query?: GetNewGradJobsPickupQuery): Promise<GetNewGradJobsPickup> => {
    return GET(PATH, query)
  }
)
